window.dataLayer = window.dataLayer || [];

import {
  clickHandler,
  determineActionText,
  queryURL,
  virtualPageview,
} from '@/ui/scripts/analytics/analytics.methods';

const eventName = 'searchResults_tracking';
const actionPropTitle = 'searchResults_action';
const labelPropTitle = 'searchResults_label';

const elements = [...document.getElementsByClassName('js-search-results-link-ga')];
const noResults = document.getElementsByClassName('js-no-search-results-ga');

function bindEventListener(el) {
  el.addEventListener(
    'click',
    clickHandler.bind(this, {
      event: eventName,
      actionProp: actionPropTitle,
      labelProp: labelPropTitle,
      action: `Click - ${determineActionText(el)}`,
      label: queryURL(el),
    }),
  );
}

function handleNoResults() {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const searchTerm = urlParams.get('searchTerm');

  virtualPageview(
    `/virtual/no-result-found/${searchTerm}`,
    `Virtual - No Result Found - ${searchTerm}`,
  );
}

function init() {
  if (!elements.length) {
    noResults.length && handleNoResults();
  }

  elements.forEach(bindEventListener);
}

export default init;
